import axios from "axios";
import store from "../store";
import Nprogress from "nprogress";

const tafsirAhlamApp = axios.create({
  baseURL: process.env.VUE_APP_ENDPOINT
});

tafsirAhlamApp.interceptors.request.use(
  config => {
    Nprogress.start();
    return config;
  },
  error => {
    // Do something with request error
    return Promise.reject(error);
  }
);
tafsirAhlamApp.interceptors.response.use(
  response => {
    Nprogress.done();
    return response;
  },
  error => {
    // Do something with response error
    return Promise.reject(error);
  }
);

export default class Request {
  resolve(request) {
    return new Promise((resolve, reject) => {
      request
        .then(response => {
          resolve(this.resolveResponse(response));
        })
        .catch(error => {
          if (error.response) {
            reject(this.resolveResponse(error.response));
          } else {
            reject(null);
          }
        });
    });
  }

  resolveResponse(response) {
    switch (response.status) {
      case 401:
        store.dispatch("logout");
        return;
    }
    return response.data;
  }

  config(config = {}) {
    if (!config.headers) {
      config.headers = {};
    }
    let headers = {
      "cache-control": "no-cache"
    };
    if (store.getters.user.accessToken) {
      headers["Authorization"] = "Bearer " + store.getters.user.accessToken;
    }
    config.headers = { ...headers, ...config.headers };
    return config;
  }

  get(name, config = {}) {
    return this.resolve(tafsirAhlamApp.get(name, this.config(config)));
  }

  post(name, data = {}, config = {}) {
    return this.resolve(tafsirAhlamApp.post(name, data, this.config(config)));
  }

  put(name, data, config = {}) {
    return this.resolve(tafsirAhlamApp.put(name, data, this.config(config)));
  }

  delete(name, config = {}) {
    return this.resolve(tafsirAhlamApp.delete(name, this.config(config)));
  }

  head(name, config = {}) {
    return this.resolve(tafsirAhlamApp.head(name, this.config(config)));
  }

  patch(name, data, config = {}) {
    return this.resolve(tafsirAhlamApp.patch(name, data, this.config(config)));
  }

  static _r = null;
  static get create() {
    if (!Request._r) {
      Request._r = new Request();
    }
    return Request._r;
  }
}
